import * as React from 'react'

import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import AdminPrestaListScreen from './AdminPrestaListScreen'
import AdminServiceScreen from './AdminServiceScreen'

interface Props {
  user: UserResponse
}

const AdminPrestaScreen = () => {
  const user = useReducer(UserStore.store, (s) => s.user)

  // screen available only for connected user
  if (!user) {
    return null
  }

  return <Screen user={user} />
}

const Screen = ({ user }: Props) => {
  const isUserChefDEquipe = user.chefEquipe

  return isUserChefDEquipe ? <AdminServiceScreen prestataireId={user.societeId} /> : <AdminPrestaListScreen />
}

export default AdminPrestaScreen
